import 'bootstrap'

import jQuery from "jquery"
window.jQuery = jQuery
window.$ = jQuery

import $ from 'jquery';
import select2 from 'select2';
import 'select2/dist/css/select2.css';
import Inputmask from "inputmask";
import "sweetalert2/dist/sweetalert2.min"
window.Swal = require('sweetalert2')

import { driver } from "driver.js";
import "driver.js/dist/driver.css";
window.driver = driver;

require("@rails/ujs").start()
const Turbolinks = require("turbolinks")
Turbolinks.start()
if (Turbolinks.HttpRequest) {
  Turbolinks.HttpRequest.timeout = 120
}
require("@rails/activestorage").start()
import consumer from "../channels/consumer"
require("channels")
//require("chart.js")
//require("Chart.extension.js")
require("jquery-scrollLock.min.js")
require("jquery.scrollbar.min.js")
require("argon.js")
require("webhook.js")
require("webhook_notification.js")
require("automation.js")
require("send_whatsapp.js")
require("custom.js")
require("custom_funil.js")
require("campaign.js")
require("whatsapp.js")
require("whatsapp_agent.js")
require("instagram_agent.js")
require("plan.js")
require("jquery-maskmoney")
require("payment.js")
require("leeds.js")
require("followup.js")
require("@nathanvda/cocoon")
require("indications.js")

global.toastr = require("toastr")

require("trix")
require("@rails/actiontext")
require("@nathanvda/cocoon")
